import { type ProductOutFull, getProductShopProductsProductIdGet } from '@/shared/api/intranet'

export const getProduct = async (
  id: number,
): Promise<{
  data: ProductOutFull | undefined
  error: unknown | undefined
  response: Response | undefined
}> => {
  const { data, error, response } = await getProductShopProductsProductIdGet({
    path: {
      product_id: id,
    },
  })

  if (!data) {
    return { data: undefined, error, response }
  }

  return { data, error, response }
}
